import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IVideosAssignmentContext,
	VideosAssignmentContext,
} from '../../../../videosAssignmentState/videosAssignmentContext';
import Video from './components/Video';
import style from './Videos.module.scss';

const Videos: React.FC = () => {
	const { videosForAssign } = useContext<IVideosAssignmentContext>(VideosAssignmentContext);

	return (
		<div className={style.container} data-test="Videos">
			<div className={style.tableOfContents}>
				<Text
					className={style.name}
					translationNameSpace="listing"
					translationKey="nameLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={style.studio}
					translationNameSpace="listing"
					translationKey="studioLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={style.category}
					translationNameSpace="listing"
					translationKey="categoryLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{videosForAssign.videos.map((el) => (
				<Video data={el} key={el.id + 'gameList'} />
			))}
		</div>
	);
};

export default Videos;
